import { render, staticRenderFns } from "./Attests.vue?vue&type=template&id=e0e82524"
import script from "./Attests.vue?vue&type=script&lang=js"
export * from "./Attests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports